import MapChart from './MapChart'

export default MapChart
